// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_8Mwom","icon":"uSOih"};